import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import Page from '../../components/page';
import cx from 'classnames';
import xauCss from '@src/components/xfe-animation-css';
import Button from '@src/components/button';
import BackTopFooter from '@src/business-components/backtop-footer';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import redirect from '@src/utils/redirect-if-mobile-accress';
// PC端页面，如果是移动端访问，跳转到移动端页面
redirect.redirectIfMobile();
const styles = require('./index.less');

const MechaUnit = ({ store }) => {
  store.use();
  return (
    <React.Fragment>
      <Page className={cx(styles.MechaUnitRoot, store.isActive && xauCss.AOS_ROOT, 'page-main')}>
        <div className={styles.unitContainer}>
          <div className={cx(styles.btnBack, { ...xauCss.AOS_FADE.IN_RIGHT.FAST_DELAY(1) })}>
            <Button
              className={styles.btnBackInner}
              onClick={store.back}
              style={{ backgroundImage: `url(${require('./images/' + getLanguageByPath() + '/btn-back.png')})` }}
            />
          </div>
          <div className={styles.topBox}>
            <div className={styles.pageIconBox}>
              <div className={styles.pageIcon1} />
              <div className={styles.pageIcon2} />
            </div>

            <div className={styles.line1} />
            <div className={styles.topRight}>
              <div className={styles.nameBox} style={{ backgroundImage: `url(${store?.mechaData?.mechaName})` }} />
              <div className={styles.btnPlayBox} onClick={store?.playVideo}>
                <div className={styles.btnPlay} />
              </div>
            </div>
            <div className={styles.bottomLIne} />
          </div>
          <div className={styles.airframeBox}>
            <div className={styles.structureImg} style={{ backgroundImage: `url(${store?.mechaData?.mechaImg})` }} />
            <div className={styles.per} style={{ backgroundImage: `url(${store?.mechaData?.driverImg})` }} />
          </div>
          <div className={styles.containerBox}>
            <div className={styles.containerBoxBg} />
            <div className={cx(styles.contontBox)}>
              {/* 驾驶员故事 */}
              <div className={styles.leftBox}>
                <div className={styles.leftContent}>
                  <div
                    className={styles.leftTitle}
                    style={{ backgroundImage: `url(${require('./images/' + getLanguageByPath() + '/driver-story-title.png')})` }}
                  />
                  <div className={styles.storyBox}>
                    <div className={styles.driversNameBox}>
                      <div className={styles.driverName}>{store?.mechaData?.driverName}</div>
                      <div className={styles.driverType}>{store?.mechaData?.driverType}</div>
                    </div>
                    <div className={styles.badge}>
                      <div className={styles.iconBadge} style={{ backgroundImage: `url(${store?.mechaData?.iconBadge})` }} />
                    </div>
                    <div className={styles.basicInfo}>
                      <div className={styles.title}>{store?.pageData?.basicInfoTitle}</div>
                      <div className={styles.infoBox}>
                        <div className={styles.info}>{store?.mechaData?.driversSex}</div>
                        <div className={styles.info}>{store?.mechaData?.driversBirthplace}</div>
                        <div className={styles.info}>{store?.mechaData?.driversStructure}</div>
                      </div>
                    </div>
                    <div className={cx(styles.basicInfo, styles.experience)}>
                      <div className={styles.title}>{store?.pageData?.roleExperSubTitle}</div>
                      <div className={styles.infoBox}>
                        <div className={styles.info}>{store?.mechaData?.driversRoleExperText}</div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 驾驶员语音 */}
                <div className={styles.driverVoiceBox}>
                  <div className={styles.pageIconBox}>
                    <div className={styles.pageIcon1} />
                    <div className={styles.pageIcon2} />
                  </div>
                  <div className={styles.driverVoiceTitle}>{store?.pageData?.driverVoiceTitle}</div>
                  {store?.cvTab?.length > 0 && <div className={styles.cr}>{store?.cvTab[store?.cvTabIndex].name}</div>}

                  <div className={cx(styles.change)} style={{ backgroundImage: `url(${require('./images/en/checked' + (store?.cvTabIndex + 1) + '.png')})` }}>
                    {store.cvTab?.map((item, tabIndex) => (
                      <div
                        key={tabIndex}
                        className={cx(styles.changeItem, styles[`changeItem-${item.value}`], store?.cvTabIndex === tabIndex && styles[`on`])}
                        onClick={() => store?.switchCvTab(tabIndex, item.lang)}
                      >
                        {item.lang}
                      </div>
                    ))}
                  </div>
                  <ul className={styles.voiceUl}>
                    {store.cvList?.map((item, index) => {
                      return (
                        <li key={index} className={cx(styles.voiceLi, item.isPlay && styles.active)}>
                          <div className={styles.btnPlay} onClick={() => store?.onClickPlayRoleAudio(index)} />
                          <div className={styles.voiceTitle}>{item.title}</div>
                          {item.isPlay && (
                            <div className={styles.soundBox}>
                              <img className={styles.screen} src={require('./images/audio-screen.png')} alt="" />
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              {/* 机兵信息 */}
              <div className={styles.rightBox}>
                <div className={styles.rightContent}>
                  <div className={styles.storyBox}>
                    <div className={styles.driversNameBox}>
                      <div className={styles.driverName}>{store?.mechaData?.mechaInfoType}</div>
                    </div>
                    <div className={styles.basicInfo}>
                      <div className={styles.title}>{store?.mechaData?.basicInfoTitle}</div>
                      <div className={styles.infoBox}>
                        <div className={styles.info}>{store?.mechaData?.mechaInfoNums}</div>
                        <div className={cx(styles.info, styles.headHigh)}>{store?.mechaData?.mechaInfoHeadHigh}</div>
                        <div className={styles.info}>{store?.mechaData?.mechaInfoEmptyWeight}</div>
                        <div className={styles.info}>{store?.mechaData?.mechaInfoTotal}</div>
                      </div>
                    </div>
                    <div className={cx(styles.basicInfo, styles.experience)}>
                      <div className={styles.pageIconBox}>
                        <div className={styles.pageIcon1} />
                        <div className={styles.pageIcon2} />
                      </div>
                      <div className={styles.title}>{store?.pageData?.mechaStorySubTitle}</div>
                      <div className={cx(styles.infoBox, styles.infoBoxjibing)}>
                        <div className={styles.info}>{store?.mechaData?.mechaInfoStory}</div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={styles.rightTitle}
                    style={{ backgroundImage: `url(${require('./images/' + getLanguageByPath() + '/mecha-info-title.png')})` }}
                  />
                </div>
                <div className={cx(styles.carmakers)}>
                  <div className={styles.pageIconBox}>
                    <div className={styles.pageIcon1} />
                    <div className={styles.pageIcon2} />
                  </div>
                  <div className={styles.carmakersContBox}>
                    <div className={styles.title}>{store?.mechaData?.manufacturerGruopCh}</div>
                    <div className={styles.badge}>
                      <img className={styles.maLogo} src={store?.mechaData?.maLogo} alt="生厂商logo" />
                    </div>
                  </div>
                  <div
                    className={styles.carmakersTitle}
                    style={{ backgroundImage: `url(${require('./images/' + getLanguageByPath() + '/manufacturer-title.png')})` }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <BackTopFooter theme="yellow" />
      </Page>
    </React.Fragment>
  );
};

export default wrapStore(MechaUnit, Store);
